import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import config from "./config/config";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider {...config.COGNITO_CONFIGURATION}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
